import { ROLES } from '../../utils/constants';

/** Backend still enforces this. The menu and route guard are not the security boundary. */
export const BILLING_ALLOWED_ROLES = [ROLES.SUPERADMIN];

export function canSeeBillingNav(role) {
  return role === ROLES.SUPERADMIN;
}
